import type { ChatSession } from "../session"

/**
 * Runs an HTTP call the UI makes (groups, handles, attachments) with the
 * session token. These live behind the runtime rather than in the components
 * because the token is private to it — a modal cannot hold one.
 *
 * Needs a token, not a live socket. These are HTTP; the socket is only for
 * sending stanzas. Boot seeds the conversation list before the client exists,
 * so the rows resolve their names and faces while it is still being built —
 * demanding readiness here left them on the loading ellipsis until something
 * remounted them.
 *
 * Unlike the fire-and-forget paths, these rethrow: the caller is a modal or a
 * react-query hook that shows the failure. The session still refreshes, so a
 * retry runs against a live token.
 */
export function call<T>(
  session: ChatSession,
  fn: (token: string) => Promise<T>
): Promise<T> {
  const token = session.token
  if (!token) return Promise.reject(new Error("chat not connected"))

  return fn(token).catch((error: unknown) => {
    session.refreshOn401(error)
    throw error
  })
}
